import clsx from 'clsx';
import { Box } from '@alf/uikit';

import styles from './index.module.css';

export const CardSkelet = ({ className }) => (
  <Box className={clsx(styles.root, className)}>
    <div className={styles.item} />
    <div className={styles.item} />
    <div className={styles.item} />
    <div className={styles.item} />
    <div className={styles.item} />
  </Box>
);
